<template>
  <div class="card mb-4">
    <div class="card-header pb-0">
      <div class="row">
        <div class="col">
          <h6>EDITAR PROCESO PRIMARIO</h6>
        </div>
      </div>
    </div>
    <div class="card-body px-4">
        <div class="row" v-if="primary_process">
          <div class="col-lg-6 col-md-6 col-sm-12">
            <label>Titulo</label>
            <input type="text" class="form-control" v-model="primary_process.title">
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12">
            <label>Descripcion</label>
            <textarea type="text" class="form-control" v-model="primary_process.description" rows="5"></textarea>
            <button class="btn bg-gradient-success w-100 mt-4" @click="updatePrimaryProcess">ACTUALIZAR PROCESO PRIMARIO</button>
          </div>
        </div>
    </div>
  </div>

</template>
<script>
import Swal from "sweetalert2";
import {get, post} from "@/utils/httpRequest";

export default {
  name: 'EditProcessPrimary',
  data: () => ({
    process_id: null,
    primary_process: null
  }),
  mounted() {
    this.process_id = this.$route.query.id
    this.getData()
  },
  methods: {
    async getData() {
      const {data} = await get(`main-process/find-one?id=${this.process_id}`)
      this.primary_process = data
    },
    async updatePrimaryProcess() {
      if(this.primary_process.title !== '' && this.primary_process.description !== ''){
        await post('main-process/update', this.primary_process)
        await Swal.fire('Informacion actualizada correctamente', '', 'success')
        this.$router.push('/primary-process')
      }else{
        await Swal.fire('Todos los campos son requeridos', '', 'error')
      }
    }
  }
}

</script>
<style scoped>

</style>
